module.exports = __webpack_public_path__ + "static/media/icon_radio.fe7c3400.svg";